<template>
  <Unfunded></Unfunded>
</template>

<script>
import Unfunded from "../components/Unfunded.vue";
export default {
  name: "Portofolio",
  components: {
    Unfunded
  }
};
</script>
